import React from "react";

import {Network, L3} from "../../services/NetworkApi";
import { CreateRoomModal } from "../../routes/super_admin/network_settings/modals/CreateRoomModal";

import { RoomTreeItem } from "./RoomTreeItem";
import { EnhancedTreeItem } from "./EnhancedTreeItem";
import { useUpdateUnit } from "./useUpdateUnit";
import { IProps as ISubnetworksTreeProps } from "./SubnetworksTree";
import {UnitTypeDeleteButtonWrapper} from "./UnitTypeDeleteButton";

interface IProps extends ISubnetworksTreeProps {
  subnetwork: Network;
  unitType: L3;
}

export const UnitTypeTreeItem: React.FC<IProps> = (props) => {
  const { handleRename, handleSizeUpdate, handleInSameRoomUpdate } = useUpdateUnit(
    props.subnetwork.l2Id,
    props.unitType.l3Id
  );
  const [isCreateRoomModal, setIsCreateRoomModal] = React.useState(false);

  const title = props.isPreview
    ? `UNIT: ${props.unitType.name}`
    : `Unit Name: ${props.unitType.name}`;
  const l3Title = `L3 Id: ${props.unitType.l3Id}`;
  const roomSizeTitle = props.isPreview
    ? `MAX USERS IN UNIT: ${props.unitType.size + 1}`
    : `Unit Size (Total users in unit): ${props.unitType.size + 1}`;

  const inSameRoomValue = props.unitType.inSameRoomEnabled ? "Yes" : "No";
  const inSameRoomFragmment = "Suite Mates Enabled: ";
  const inSameRoomTitle = inSameRoomFragmment + inSameRoomValue;

  const nodeId = `${props.subnetwork.l1Name}-${props.subnetwork.l2Id}-${props.unitType.l3Id}`;

  const openCreateRoomModal = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    setIsCreateRoomModal(true);
  };

  const closeCreateRoomModal = () => setIsCreateRoomModal(false);

  const L3CreationItems = props.subnetwork.matchingRoundStatus !== "CLOSED" && props.subnetwork.matchingRoundStatus !== "ARCHIVED"?
  [
    {label: `Add new room for ${props.unitType.name}`, handler: openCreateRoomModal}
  ] :
  [];

  return (
    <>
      <EnhancedTreeItem
        title={title}
        nodeId={nodeId}
        subtitle1={l3Title}
        subtitles={[
          {title: roomSizeTitle, value: props.unitType.size + 1, onEdit: handleSizeUpdate, maxValue: 20},
          {
            title: inSameRoomTitle,
            label: inSameRoomFragmment, 
            value: props.unitType.inSameRoomEnabled, 
            onEdit: handleInSameRoomUpdate, 
            isCheckbox: true,
            isPreview: true
          }
        ]}
        name={props.unitType.name}
        isPreview={props.isPreview}
        onEdit1Success={handleRename}
        actionButtons={L3CreationItems}
        deleteButton={<UnitTypeDeleteButtonWrapper levelName={props.unitType.name} l1Id={props.subnetwork.l1Id} l2Id={props.subnetwork.l2Id} l3Id={props.unitType.l3Id}/>}
      >
        {props.unitType.l4?.map((l4) => (
          <RoomTreeItem
            l4={l4}
            l1Id={props.subnetwork.l1Id}
            l2Id={props.subnetwork.l2Id}
            l3Id={props.unitType.l3Id}
            key={`${nodeId}-${l4.l4Id}`}
            isPreview={props.isPreview}
            nodeId={`${nodeId}-${l4.l4Id}`}
          />
        ))}
      </EnhancedTreeItem>
      {!props.isPreview && (
        <CreateRoomModal
          show={isCreateRoomModal}
          l3Id={props.unitType.l3Id}
          l3Name={props.unitType.name}
          l1Id={props.subnetwork.l1Id}
          l2Id={props.subnetwork.l2Id}
          onClose={closeCreateRoomModal}
        />
      )}
    </>
  );
};
